import React from 'react';
import * as yup from 'yup';
import TaxForm from "./TaxForm";

import { toast } from "react-toastify";
toast.configure();


const AddEditTax = (props) => {

    const {
        show,
        editValues,
        currency,
        modalType,
        taxList,
        setTaxList
    } = props;

    const checkBoxWarning = () => {
        toast.warning("Does this tax apply to adults, children or both? It is mandatory to select at least one.");
        return false;
    };

    const validationSchema = yup.object({
        taxType: yup.string().required("Tax type is a required field"),
        name: yup.string().required("Name of tax is a required field"),
        amount: yup.number().required("Amount is a required field").min(0, 'Must be a positive number').typeError('Must be a value of type number'),
        modality: yup.string(),
        taxApplyAdults: yup.boolean(),
        taxApplyChildren: yup.boolean().test("taxApplyChildren", "",  function(value) {
        return ["per person", "pppn"].includes(this.parent.modality)
        && !this.parent.taxApplyAdults
        && !value ? checkBoxWarning() : true
        }),
    });
    
    const initialValues = {
        name: editValues?.name || '',
        amount: editValues?.amount || '',
        taxType: editValues?.taxType || 'flat rate',
        modality: editValues?.modality || 'per stay',
        taxApplyAdults: editValues?.taxApplyAdults || false,
        taxApplyChildren: editValues?.taxApplyChildren || false,
    };

    const handleSubmit = (data) => {
        const taxObject = {
            name: data.name,
            taxType: data.taxType,
            amount: Number(data.amount),
            modality: data.modality,
            taxApplyAdults: Boolean(Number(data.taxApplyAdults)),
            taxApplyChildren: Boolean(Number(data.taxApplyChildren)),
        };

        if (editValues) {
            const updateTaxList = taxList;
            updateTaxList[editValues.index] = taxObject;
            setTaxList(updateTaxList);
        } else {
            setTaxList([...taxList, taxObject]);
        };
        
        show(false);
    };

    return (
        <TaxForm
            showTax={(e) => show(e)}
            initialValues={initialValues}
            validationSchema={validationSchema}
            handleSubmit={handleSubmit}
            currency={currency}
            modalType={modalType}
        />
    )
};

export default AddEditTax;